$modal = '';
function modal_popup(element){
  // Get the modal
  var getattrId = element.getAttribute('data-id');
  $modal = document.getElementById(getattrId);
  $modal.style.display = "block";
  $modal.classList.add('page-modal--active');
  $('body').addClass('body-modal--active');
}

  // When the user clicks anywhere outside of the modal, close it
  window.onclick = function(event) {
    if (event.target == $modal) {
      $modal.style.display = "none";
      $modal.classList.remove('page-modal--active');
      $('body').removeClass('body-modal--active');
      
    }
  }
  // When the user clicks on close button, close it
  var close_data = document.querySelectorAll('.modal__close');
  close_data.forEach((clk) => {
    clk.addEventListener("click", function(){
      $modal.style.display = "none";
        $modal.classList.remove('page-modal--active');
        $('body').removeClass('body-modal--active');
    });
  });

//document.querySelectorAll(".border-fin1,.fin-text,.border-fin2").style.display = 'none';
var openModalButtons = document.getElementsByClassName("openModalButton");
var modalContainers = document.getElementsByClassName("popUpBoxs-container");

document.querySelector("body")
var addModalClickEvent = function (e) {
  //Show Modal
  let popUpBox = e.target.previousElementSibling;
  popUpBox.style.display = "block";
  document.querySelector("body").style.overflowY = "hidden";
};

for (var i = 0; i < openModalButtons.length; i++) {
  openModalButtons[i].addEventListener('click', addModalClickEvent, false);
}
for (var i = 0; i < modalContainers.length; i++) {
  modalContainers[i].addEventListener('click', checkForModalCloseEvent, false);
}
function closeModalPopup() {
  document.querySelectorAll('.popUpBoxs-container').forEach(function (el) {
    el.style.display = "none"
  });
  document.querySelector("body").style.overflowY = "unset";
}
function checkForModalCloseEvent(e) {
  if (!e.target.src) {
    closeModalPopup();
  }
}
window.closeModalPopup = closeModalPopup;

function StopCartOpen(event) {
  event.preventDefault();
}